export default "__VITE_ASSET__0dSS0_1t__"